import classNames from 'classnames';
import type React from 'react';

type Size = 'sm' | 'md';

export interface RuleIconProps {
  backgroundImageUrl?: string;
  size?: Size;
  borderColor?: 'border-ds-natural-150' | 'border-ds-primary-300';
  children?: React.ReactNode;
}

const transparentBackgroundImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAADFJREFUOE9jZGBgEGHAD97gk2YcNYBhmIQBgWSAP52AwoAQwJvQRg1gACckQoC2gQgAIF8IscwEtKYAAAAASUVORK5CYII=';

const sizeToDimensions: Record<Size, string> = {
  sm: 'w-5 h-5',
  md: 'w-6 h-6',
};

const sizeToBorderRadius: Record<Size, string> = {
  sm: 'rounded',
  md: 'rounded-md',
};

export const RuleIcon = ({
  backgroundImageUrl,
  size = 'md',
  borderColor = 'border-ds-natural-150',
  children,
}: RuleIconProps) => {
  return (
    <div
      className={classNames(
        'flex flex-col flex-shrink-0 justify-center items-center overflow-hidden border text-ds-primary-300',
        borderColor,
        sizeToDimensions[size],
        sizeToBorderRadius[size],
        !backgroundImageUrl && 'p-0.5'
      )}
      style={{
        background:
          backgroundImageUrl &&
          `url(${transparentBackgroundImage}) left center`,
        backgroundSize: '4px',
      }}
    >
      {backgroundImageUrl ? (
        <div
          className="w-full bg-contain bg-no-repeat bg-center h-full"
          style={{
            backgroundImage: `url(${backgroundImageUrl})`,
          }}
        />
      ) : (
        children
      )}
    </div>
  );
};
